import { createTheme, ThemeOptions } from '@material-ui/core';

const DarkTheme = createTheme({
  palette: {
    type: 'dark',
  },
} as ThemeOptions);

export default DarkTheme;
